<button (click)="onClickFunction()">
  {{ plan.name }}
  <hr/>
  Liczba minut: {{plan.units / 60}}<br/>
  Ważność minut: {{plan.validity}} dni<br/>
  Cena: {{plan.priceUSD}} USD
</button>
